<form [hidden]="!showCredentials" [formGroup]="formGroup" class="d-flex flex-row align-items-start mt-4" (ngSubmit)="submitGitCredential()" novalidate>
    <div class="mb-0 d-flex">
        <div class="d-flex flex-column me-2">
            <input
                type="text"
                class="form-control mt-1 me-1"
                formControlName="username"
                placeholder="Your Username"
                [ngClass]="formGroup.get('username')?.errors && formGroup.get('username')?.touched ? 'has-error' : ''"
            />
            <small *ngIf="formGroup.get('username')?.touched && formGroup.get('username')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="d-flex flex-column me-2">
            <input
                type="password"
                class="form-control mt-1"
                formControlName="password"
                placeholder="Your Password"
                [ngClass]="formGroup.get('password')?.errors && formGroup.get('password')?.touched ? 'has-error' : ''"
            />
            <small *ngIf="formGroup.get('password')?.touched && formGroup.get('password')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
    </div>
    <button type="submit" class="btn btn-primary mt-1" [disabled]="updating">{{ hasGitCredentials ? 'Update' : 'Save' }}</button>
</form>
